import styled from '@emotion/styled';

export const ButtonWrapper = styled.div`
  width: 300px;
  margin: 0 auto;
  margin-top: ${({ theme, mt }) => theme.spacings[mt || 0]};
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

export const ButtonsWrapper = styled.div`
  margin-top: auto;
`;
